import { LoadablePaint } from '@confluence/loadable';

export const EmbeddedEditPageLoader = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-edit-pageEmbeddedEditPage" */ '../src/edit-page/EmbeddedEditPage.tsx'
			)
		).EmbeddedEditPage,
});
